// extracted by mini-css-extract-plugin
export default {"button":"Nle-a","link":"zNV70","container":"WH4l-","mobile-container":"_16XIq","mobileContainer":"_16XIq"};